import IconHOC from '../IconHOC';

import { ReactComponent as MoreVerticalIcon } from './moreVertical.svg';

export const MoreVertical = IconHOC(MoreVerticalIcon);
